import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_cabane } from '@store/cabane.slice';
import WorkPage from '../../components/WorkPage';

const Cabane = () => {
  const { cabane, is_fetching_cabane } = useSelector((state) => state.cabane);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(cabane).length === 0 && cabane.constructor === Object) {
      fetch();
    }
  }, []);

  const fetch = async () => {
    await dispatch(fetch_cabane());
  };

  const CabaneComponent = useMemo(() => {
    if (!(Object.keys(cabane).length === 0 && cabane.constructor === Object)) {
      return (
        <WorkPage
          images={cabane.photo_gallery.images[0].concat(cabane.videos || [])}
          text={cabane}
        />
      );
    } else {
      return <> </>;
    }
  }, [cabane]);

  return <>{CabaneComponent}</>;
};

export default Cabane;
